import * as React from 'react'
import { Search } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Input } from '@/components/ui/input'

/**
 * The one search field: an `Input` (type `search`, so it reads as a
 * searchbox) with a decorative magnifier at a fixed offset. The icon never
 * takes a click or an announcement; give the field an `aria-label` (or a
 * `<label htmlFor>`), and end its placeholder with `…`.
 *
 * `className` sizes the wrapper (it sits in the layout); `inputClassName`
 * reaches the input (height, padding). `children` render inside the wrapper,
 * after the input, for an inline clear button.
 *
 * @param {Object} props - the `Input`'s props, plus:
 * @param {string} [props.className] - wrapper classes
 * @param {string} [props.inputClassName] - input classes
 * @param {React.ReactNode} [props.children]
 * @returns {JSX.Element}
 */
const SearchInput = React.forwardRef(({ className, inputClassName, type = 'search', children, ...props }, ref) => (
  <div className={cn('relative', className)}>
    <Search aria-hidden="true" className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-ink-2" />
    <Input ref={ref} type={type} className={cn('pl-9', inputClassName)} {...props} />
    {children}
  </div>
))
SearchInput.displayName = 'SearchInput'

export { SearchInput }
